import { usePartnersPageContent } from '../../features/partners/hooks/usePartnersPage';
import { Button } from '@/components/ui/button';

interface CTASectionProps {
  onCtaClick?: () => void;
}

export function CTASection({ onCtaClick }: CTASectionProps) {
  const { partnerPageContent } = usePartnersPageContent();
  const cta = partnerPageContent.finalCta;

  const title = cta.title;
  const subtitle = cta.description;
  const buttonText = 'Start Your Partnership';

  const handleClick = () => {
    if (onCtaClick) {
      onCtaClick();
    } else {
      const element = document.querySelector('#inquire');
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      className="bg-gradient-to-r from-primary to-primary-dark py-16 text-primary-foreground md:py-24"
      aria-labelledby="cta-title"
    >
      <div className="container mx-auto px-4 text-center">
        <h2 id="cta-title" className="font-display text-3xl md:text-4xl font-bold mb-4">
          {title}
        </h2>
        <p className="text-xl opacity-90 mb-4 max-w-2xl mx-auto">{subtitle}</p>
        <p className="mb-8 text-sm font-semibold uppercase tracking-[0.3em] text-primary-foreground/75">
          {cta.callout}
        </p>
        <Button
          onClick={handleClick}
          type="button"
          className="h-12 rounded-full bg-background px-8 text-base font-semibold text-primary shadow-card transition-transform duration-200 hover:-translate-y-0.5 hover:bg-background/95 focus-visible:ring-background focus-visible:ring-offset-primary"
        >
          {buttonText}
        </Button>
      </div>
    </section>
  );
}

export default CTASection;
